export default "__VITE_ASSET__TFE1QVHW__"